import type { FormItem } from '#/common/components/Form';

export const extractFieldNames = <T = any>(
  items: FormItem<T>[],
  excludeFields: string[] = []
): string[] => {
  const fieldNames: string[] = [];

  const extract = (formItems: FormItem<T>[]): void => {
    formItems.forEach((item) => {
      if ('dataField' in item && item.dataField && !excludeFields.includes(item.dataField)) {
        fieldNames.push(item.dataField);
      }

      if ('items' in item && Array.isArray(item.items)) {
        extract(item.items);
      }
    });
  };

  extract(items);
  return fieldNames;
};